import {
  SETTING_CHANGE_MESSAGE,
} from 'constants/messageTypes';


export default function opportunitiesShouldFetch(messages = {}, opportunityQualityRequirementIds) {
  const {
    headlineMessages = [],
    hiddenMessages = [],
    standardMessages = [],
    defaultMessages = [],
    areaMessage
  } = messages;

  const qualityRelevantToCurrentPlansHasChanged = [
    ...headlineMessages,
    ...hiddenMessages,
    ...standardMessages,
  ].some(({ qualityId }) => opportunityQualityRequirementIds.includes(qualityId));

  const settingHasChanged = defaultMessages.some(({ type }) => type === SETTING_CHANGE_MESSAGE);
  const areaHasChanged = !!areaMessage;

  return qualityRelevantToCurrentPlansHasChanged || settingHasChanged || areaHasChanged;
}